<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-trends-10-html">
      <h1 class="report-component-title">{{ title }}
        <sup v-if="title === 'ITR Trends 10'">™</sup>
      </h1>
      <p class="report-component-section">{{ section }}</p>
      <p class="report-component-date">Published {{ publishDate }}</p>
      <div class="trends-10-image">
        <img :src="cwaData.ImageBase64" alt="Trends 10 Image" />
      </div>
      <h4 class="margin-top">OVERVIEW</h4>
      <div class="report-component-body" v-html="cwaData.OverviewText"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TrTrends10Template',
    components: {},
    props: {
      title: {
        type: String,
        required: true,
      },
      cwaData: {
        type: Object,
        required: true,
      },
      section: {
        type: String,
        required: false,
      },
      publishDate: {
        type: String,
        required: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .reportWrapper {
    font-family: 'Open Sans', sans-serif !important;
    page-break-inside: avoid;
    .report-component-title {
      font-size: 40px;
      color: var(--itr-blue);
    }
    h4 {
      font-size: 18px;
      line-height: 1.3;
      font-weight: 800;
      color: var(--itr-blue);
      margin-bottom: 12px;
      text-transform: uppercase;
    }
    .margin-top {
      margin-top: 75px;
    }
    .report-component-section {
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 26px;
      font-family: 'Open Sans', sans-serif;
    }
    .report-component-date {
      color: var(--itr-grey-charcoal);
      font-size: 22px;
      font-style: italic;
    }

    .report-component-body {
      * {
        font-size: 18px;
        color: var(--itr-grey-dark);
        background-color: transparent;
        font-family: 'Open Sans', sans-serif;
      }
    }
    .trends-10-image {
      text-align: center;
      margin-top: 2rem;
    }
  }
</style>
